import Root from './app/index';


function App() {
  return <Root />;
}

export default App;
